module.exports = __webpack_public_path__ + "img/refferal-bg.789a4e7d.svg";